/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Token/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromValidate from 'Simple/Data/validate.js'
import React from 'react'
import TysiaInputWithLabelField from 'DesignSystem/TysiaInputWithLabelField/index'



/** @type {import('Simple/types.js').View} */
export default function Token({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content/Connections/Content/AddAction/ApiToken/Token",
  onChange,
  isInvalid
  
}) {
let appTokenValueData = fromData.useDataValue({ viewPath,
context: 'app',
path: 'token',
})
let appTokenIsValidData = fromData.useDataIsValid({ viewPath,
context: 'app',
path: 'token',
validate: fromValidate.textAtLeastOneChar,
required: true,
})
let appTokenChangeData = fromData.useDataChange({ viewPath,
context: 'app',
path: 'token',
})
  return (<React.Fragment
>
<TysiaInputWithLabelField
  viewPath={`${viewPath}/TysiaInputWithLabelField`}
 marginTop={0}
 type="text"
 autoFocus={true}
 label="API token"
 data="app.token"
 onChange={appTokenChangeData}
 value={appTokenValueData}
 required={true}
 validate="/Simple/Data/validate.js textAtLeastOneChar"
 invalid={!appTokenIsValidData}
/>
{children}
</React.Fragment>)
}